/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import GetSiteStatusBanner from '@/services/GetSiteStatusBanner';

import InternalLoginPage from '../pages/InternalLoginPage';

export default async function ShowInternalLoginPage() {
  // Messenger().hideAll();
  let siteStatusBanner;

  try {
    siteStatusBanner = await GetSiteStatusBanner();
  } catch (e) {
    siteStatusBanner = null;
  }

  Scaffold.getRegion('content').show(
    new InternalLoginPage({
      model: new Backbone.Model({
        siteStatusBanner
      })
    })
  );
}
